module.exports = __webpack_public_path__ + "static/media/4.46f627f1.jpg";